import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N20 } from '@atlaskit/theme/colors';
import { FormGrid } from '../../../common/ui/FormGrid/styled';
// FIXME: convert-props-syntax rule doesn't catch this
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LoadingForm = styled(FormGrid)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\ttransition-property: opacity;\n\ttransition-duration: 300ms;\n\tbackground-color: ", ";\n\ttext-align: left;\n\n\topacity: ", ";\n\tz-index: 1;\n\tpointer-events: ", ";\n"])), "var(--ds-surface, #FFFFFF)", function (_ref) {
  var visible = _ref.visible;
  return visible ? 1 : 0;
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'auto' : 'none';
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Skeleton = styled.div({
  display: 'inline-block',
  backgroundColor: "var(--ds-skeleton, ".concat(N20, ")"),
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  borderRadius: '3px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LabelSkeleton = styled(Skeleton)({
  width: '98px',
  marginBottom: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FieldSkeleton = styled(Skeleton)({
  width: '100%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  padding: '10px 0',
  margin: 0,
  boxSizing: 'border-box',
  border: '2px solid transparent',
  lineHeight: '1.2em'
});